const pictogramHu = {
	pictogramTable: 'Pictogram',
	pictogramEditForm: 'Pictogram',
	name: 'Name',
	file: 'Pictogram'
};

export default pictogramHu;
